// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    justify-self: center;
    align-items: center;
    flex-direction: column;
    margin-top: 12rem;
}

.login-build-version {
    color: #999999;
    margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/authentication/login/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".login-container {\r\n    display: flex;\r\n    justify-self: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    margin-top: 12rem;\r\n}\r\n\r\n.login-build-version {\r\n    color: #999999;\r\n    margin-top: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
